import { useEffect } from 'react'
import { ADMIN_URL } from '../lib/env'
import { useT } from '../lib/i18n'

/**
 * `/admin` outlives the page (docs/CONTRACT.md §11). Approvals, members, invites and recovery
 * links moved to the console — its own site — so this route only forwards an old bookmark there.
 * It sits outside the app shell on purpose: no socket, no chat list, no LiveKit chunk on the way
 * out, and it works whether or not the visitor is signed in here.
 */
export function AdminRedirectPage() {
  const t = useT()
  useEffect(() => {
    window.location.replace(ADMIN_URL)
  }, [])

  return (
    <div className="app-shell items-center justify-center gap-3 px-6 text-center">
      <h1 className="text-title font-semibold text-ink">{t('adminRedirect.title')}</h1>
      <p className="max-w-[26rem] text-ui text-muted">
        {t('adminRedirect.body')}{' '}
        <a className="text-accent underline underline-offset-4" href={ADMIN_URL}>
          {ADMIN_URL}
        </a>
        .
      </p>
    </div>
  )
}
